/* eslint-disable prefer-template */
import styled, { css } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Checkbox from 'syf-component-library/ui/atoms/Checkbox'
import { MultiSelectStylesProps } from './typings'

const width = 200
const padding = 10
const redColor = '#c63527'
const grayColor = '#fafafa'
const bgColor = '#f3f3f3'
const borderColor = '#979797'
const boxShadow = css`
  box-shadow: 0 0 0 1px #94969a;
`
const widthBase = css`
  width: ${width}px;
`
const widthWrapper = css`
  width: ${width + padding * 2}px;
`
const paddingBase = css`
  padding: 0 ${padding}px;
`

export const Container = styled.div`
  padding: 3px;
  ${widthBase}
`

export const Header = styled.div<MultiSelectStylesProps>`
  position: relative;
  width: 100%;
  height: 55px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  ${boxShadow}
  ${({ error }) => (error ? 'box-shadow: 0 0 0 2px ' + redColor + ';' : '')}
    ${paddingBase}
  ${({ disabled }) => (disabled ? 'background-color: ' + grayColor + ';' : '')}
`

export const SelectedWrapper = styled.div`
  display: flex;
  padding-right: 20px;
  max-width: 100%;
  overflow: hidden;
`

export const ItemsSelected = styled.div<MultiSelectStylesProps>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  ${widthBase}
  ${({ disabled }) => !disabled && 'cursor: pointer;'}
`

export const SearchContainer = styled.div`
  display: flex;
  background-color: ${bgColor};
  box-sizing: border-box;
  align-items: center;
  border-bottom: 1px solid ${borderColor};
  &:focus,
  &:focus-visible {
    outline-width: 0;
  }
`

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 0.5rem;
`

export const SearchInput = styled.input`
  border-width: 0;
  background-color: ${bgColor};
  padding: 13px 10px;
  padding-left: 40px;
  font-size: 14px;
  width: 100%;
`

export const OptionsWrapper = styled.div`
  position: relative;
  margin: 2px;
  background-color: white;
  border-radius: 3px;
  z-index: 1;
  ${widthWrapper}
  ${boxShadow}
`

export const OptionsContainer = styled.div`
  position: relative;
  max-height: 350px;
  border: 1px solid ${borderColor};
  overflow-y: auto;
  padding: 5px;
  & > label {
    justify-content: flex-start;
  }
`

export const ErrorMessage = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 5px 0;
  color: ${redColor};
`

export const CloseButton = styled.button`
  background-color: inherit;
  border: 0;
  cursor: pointer;
`

export const Unselect = styled.span`
  color: ${borderColor};
  font-size: small;
  font-weight: bold;
  cursor: pointer;
`

export const PlaceHolder = styled.span`
  opacity: 0.9;
  font-size: small;
`

export const NoOptions = styled.span`
  display: block;
  width: 100px;
  margin: 3px auto;
`

export const Chevron = styled(FontAwesomeIcon)<MultiSelectStylesProps>`
  position: absolute;
  cursor: pointer;
  right: 12px;
  ${({ error }) => (error ? 'color: ' + redColor + ';' : '')}
`
